import r from "./design-system.es126.js";
import { toastKey as n } from "./design-system.es7.js";
const s = () => {
  const t = r();
  return {
    emitter: t,
    open: (e) => {
      t.emit("open", e);
    }
  };
}, c = () => {
  const t = s();
  return t.install = (o) => {
    o.config.globalProperties.$toastEmitter = t.emitter, o.config.globalProperties.$toast = t.open, o.provide(n, t);
  }, t;
};
export {
  s as createToast,
  c as createToastGlobal
};
//# sourceMappingURL=design-system.es2.js.map
